import { useState } from "react";
import { ModalShell } from "../../modals/ModalShell";

/**
 * Confirm sheet for turning off a running gut ramp. It's an athlete-level change
 * (the PATCH regenerates fuel across every plan), so the copy spells that out.
 * Owns its own busy/error state so a failed PATCH keeps the sheet open to retry.
 *
 * Extracted from `TrainingPlanWizard` (profile-steps single-source, plan A) so
 * the wizard (race + rolling on-ramp) and the My Fuel `ProfileGateSheet` share
 * ONE ramp-disable prompt (opened by `useAboutYouFuel.onDisableRamp`).
 */
export function DisableRampSheet({
  onConfirm,
  onClose
}: {
  onConfirm: () => Promise<void>;
  onClose: () => void;
}) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  return (
    <ModalShell
      eyebrow="Gut ramp"
      title="Disable gut training?"
      onClose={onClose}
      width={480}
      footer={
        <>
          <span />
          <div className="fgm-footer-actions">
            <button
              type="button"
              className="fg-btn fg-btn--ghost fg-btn--sm"
              disabled={busy}
              onClick={onClose}>
              Keep it on
            </button>
            <button
              type="button"
              className="fg-btn fg-btn--primary fg-btn--sm"
              disabled={busy}
              onClick={() => {
                setBusy(true);
                setError(null);
                onConfirm().catch((err) => {
                  setBusy(false);
                  setError(
                    err instanceof Error ? err.message : "Couldn't disable the ramp. Try again."
                  );
                });
              }}>
              {busy ? "Disabling…" : "Disable gut ramp"}
            </button>
          </div>
        </>
      }>
      <div className="fgp-modalshell__pad fgf-removecopy">
        This will disable your gut training across all of your workouts. Are you sure?
        {error && (
          <div className="fgp-modal-callout fgp-modal-callout--error" style={{ marginTop: 12 }}>
            {error}
          </div>
        )}
      </div>
    </ModalShell>
  );
}
